<script>
    import Field from './Field.svelte?1733898724664';
    import RangeSlider from '/srv/web/wyvr/html/releases/58819/gen/client/vendor/svelte-range-slider-pips/RangeSlider.svelte?1733898724664';
    import { get_values_from_products } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/facet/block/slider_helper.js?1733898724664';

    export let name = '';
    export let value = undefined;
    export let headline;
    export let list;
    export let step = 1;
    export let unit;

    let data;
    let from;
    let to;
    let timer;
    let min;
    let max;
    let slider_values = [0, 1];
    let initialMax = undefined;
    let initialMin = undefined;
    let initialized = false;

    // used primarily to reset the values
    $: update_values(value);

    // when the products change, also update the limits
    $: update_limits(list);

    // debounce and update all values
    function update() {
        clearTimeout(timer);
        timer = setTimeout(() => {
            let f_from = Number.parseFloat(from);
            let f_to = Number.parseFloat(to);
            if (Number.isNaN(f_from)) {
                f_from = min;
                from = min;
            }
            if (Number.isNaN(f_to)) {
                f_to = max;
                to = max;
            }
            // when outside the range reset the value
            if (f_from <= min && f_to >= max) {
                slider_values = [min, max];
                value = undefined;
                return;
            }
            value = [f_from, f_to];
            slider_values = [f_from, f_to];
        }, 500);
    }

    function update_limits(list) {
        data = get_values_from_products(list);

        if (step >= 1) {
            data.min = Math.floor(data.min);
            data.max = Math.ceil(data.max);
        } else {
            data.min = Math.floor(data.min * 10) / 10;
            data.max = Math.ceil(data.max * 10) / 10;
        }

        // Wenn initialMax nicht gesetzt ist, setzen Sie es auf data.max
        if (initialMax === undefined) {
            initialMax = data.max;
        }

        if (initialMin === undefined) {
            initialMin = data.min;
        }

        min = initialMin;
        max = initialMax; // Verwenden Sie immer den anfänglichen Maximalwert

        if (from === undefined || from < min) {
            from = min;
        }
        if (to === undefined || to > max) {
            to = max;
        }

        const new_value = [from, to];
        slider_values = new_value;
        if (value && (value[0] != new_value[0] || value[1] != new_value[1])) {
            value = new_value;
        }
    }

    function update_slider(values) {
        if (values && values.length >= 2 && (from != values[0] || to != values[1])) {
            from = values[0];
            to = values[1];
            update();
        }
    }

    function update_values(values) {
        if (value === undefined) {
            slider_values = [].concat([min, max]);
            from = min;
            to = max;
            return;
        }
        // when the facet gets initialized allow setting the value from outside, afterwards its forbidden
        if (!initialized) {
            initialized = true;
            if (Array.isArray(value) && value.length === 2) {
                slider_values = [].concat(value);
                from = value[0];
                to = value[1];
            }
        }
    }
</script>

<Field {headline}>
    {#if slider_values}
        <RangeSlider range pips values={slider_values} {min} {max} {step} on:change={(e) => update_slider(e.detail?.values)} />
    {/if}
    <div class="inputs">
        <div class="field from">
            <label for="{name}_from">
                {window.__('facet.from')}
            </label>
            <input id="{name}_from" bind:value={from} on:change={update} /><span class="unit">{unit}</span>
        </div>
        <div class="field to">
            <label for="{name}_to">
                {window.__('facet.to')}
            </label>
            <input id="{name}_to" bind:value={to} on:change={update} /><span class="unit">{unit}</span>
        </div>
    </div>
</Field>


<style>input {
    width: 100%;
    display: block;
}
.inputs {
    display: flex;
}
.field {
    position: relative;
}
.unit {
    position: absolute;
    pointer-events: none;
    bottom: 0;
    right: 0.5em;
}

    :global(.rangeSlider > .rangeHandle .rangeNub) {
        width: 20px !important;
        height: 40px !important;
        position: relative;
        background-color: var(--lightbrown);
        background-position: center center;
        background-repeat: no-repeat;
        border: 1px solid var(--darkblue);
        -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
        box-shadow: 0 0 4px rgba(0, 0, 0, 0.2) !important;
        transform: rotate(0deg) !important;
        border-radius: 0px !important;
    }
    :global(.rangeBar) {
        padding: 7px 0px !important;
        height: 25px !important;
        background-color: #040b1c !important;
    }
    :global(.range.hoverable) {
        padding: 7px 0px !important;
        height: 25px !important;
        border-radius: 0px !important;
        background-color: var(--lightbrown) !important;
        border: 1px solid var(--darkblue) !important;
    }
    :global(.rangeSlider.focus .rangeNub) {
        background-color: var(--lightbrown) !important;
    }
    :global(.rangeSlider .rangeHandle.active .rangeNub) {
        background-color: var(--lightbrown) !important;
    }
    :global(.rangePips) {
        display: none !important;
    }
    :global(.rangeHandle:hover) {
        box-shadow: none !important;
        border: none !important;
    }

    :global(.rangeNub:before) {
        left: 6px;
        position: absolute;
        top: 6px;
        display: block;
        content: '';
        height: 28px;
        width: 1px;
        background: var(--darkblue);
    }
    :global(.rangeNub:after) {
        right: 6px;
        position: absolute;
        top: 6px;
        display: block;
        content: '';
        height: 28px;
        width: 1px;
        background: var(--darkblue);
    }
    input {
        width: 100%;
        font-size: 0.875rem;
        height: 20px;
        background: rgba(0, 0, 0, 0);
        border: 1px solid #040b1c;
        text-align: center;
    }
    .inputs {
        text-align: center;
        display: flex;
        gap: 10px;
    }
    .unit {
        height: 20px;
    }
    .field.from,
    .field.to {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        height: 100%;
        font-size: var(--font-size__xs);
        padding: 0;
        border: none;
        margin: 0;
    }
</style>